export default "__VITE_ASSET__DSxzCILo__"